// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
//关闭广告
Vue.config.productionTip = false
//路由
import router from './router'
//element库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/css/home.css";
import "@/assets/css/pages.css";
import "@/assets/font/iconfont.css";
import 'element-ui/lib/theme-chalk/display.css';
import "element-ui/lib/theme-chalk/message.css";
import 'ie-placeholder'
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp)
Vue.use(ElementUI);
import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
//vuex 状态管理
import store from "./store"
//公共api地址
Vue.prototype.Url = window.apiHosts + '/';

Vue.prototype.ImgUrl = window.apiHosts + '/image/';

//页面默认的title
Vue.prototype.WindTitle="南京农业大学"

//qq登录组件控制
Vue.prototype.IsQQLogin=true

//公共组件
import DocumentsNewsBlockControl from '@/components/DocumentsNewsBlockControl/DocumentsNewsBlockControl'
import Mlogin from '@/components/MLoginControl'
import CommonPage from '@/components/CommonPage'
import ArticleList from '@/components/IssueArticleListControl/ArticleList.vue'
Vue.component("DocumentsNewsBlockControl", DocumentsNewsBlockControl)
Vue.component("Mlogin", Mlogin)
Vue.component("CommonPage", CommonPage) //分页器
Vue.component("ArticleList", ArticleList) //列表
//下载
import $Download from '@/assets/js/xiazai.js'
Vue.prototype.$Download = $Download
//打开新页面
Vue.prototype.$newOpen = function() {
	let path = arguments[0];
	if (process.env.NODE_ENV == 'production' && path.startsWith('/#')) {
		let tmp = location.pathname;

		if (tmp.endsWith('/')) {
			tmp = tmp.substring(0, tmp.length - 1);
		}
		arguments[0] = tmp + path;
	}
	window.open.apply(window, arguments);
}
//关闭/回退  可以回退就回退 没有路由就关闭页面
Vue.prototype.$closeOrBack = function() {

	if (window.history.length <= 1) {
		window.close();
	} else {
		router.go(-1);
	}
}
//回到首页
Vue.prototype.$goHome = function() {
	let path = '/#/';
	if (process.env.NODE_ENV == 'production' && path.startsWith('/#')) {
		let tmp = location.pathname;
		if (tmp.endsWith('/')) {
			tmp = tmp.substring(0, tmp.length - 1);
		}
		path = tmp + path;
	}
	location.href = path;
}
Vue.prototype.$base = function(text, type) {
	let reg = ""
	switch (type) {
		case "phone": //手机号码
			reg = /^1[345789]\d{9}$/
			break;
		case "pass": //密码必须包含字母、数字、特殊字符3种形式；特殊字符仅包括.!@#_这5种西文字符；密码须8~16位
			reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[.!@#_])[\da-zA-Z.!@#_]{8,16}$/
			break;
		case "email": //邮箱
			reg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,10}$/
			break;
		case "users": //密码
			reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*()_+`\-={}:";'<>?,.\/])[\da-zA-Z~!@#$%^&*()_+`\-={}:";'<>?,.\/]{6,16}$/
				break;
		case "name": //用户名
			reg = /[a-zA-Z0-9_]{4,16}$/
			break;
		case "aff": //非法判断
			reg = /select|update|delete|truncate|join|union|exec|install|insert|drop|count|'|"|;|>|</i
			break;
		default:
			console.log("未知正则名称:", type)
			break;
	}
	if (reg.test(text)) {
		return true
	} else {
		return false
	}
}

Vue.prototype.resetSetItem = function (key, newVal) {
	if (key === 'eqcode') {
		var newStorageEvent = document.createEvent('StorageEvent');
		const storage = {
			setItem: function (k, val) {
				sessionStorage.setItem(k, val);
				newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
				window.dispatchEvent(newStorageEvent)
			}
		}
		return storage.setItem(key, newVal);
	}
 }

 Vue.prototype.$DownloadBase64File = function(Guid,type){
	let url=""
	let params={}
	let openurl =""
	if(type ==1){
	  url = "_OpenFilebyGuid"
	  openurl = window.apiHost + "/api/Common/OpenFilebyGuid?FileGUID="
	}else if(type ==2){
	  url = "_OpenMessageFilebyGuid"
	  openurl = window.apiHost + "/api/Common/OpenMessageFilebyGuid?FileGUID="
	}
	params = {FileGUID:Guid}
	this.$store.dispatch(
	  url,
	  params
	).then(res=>{
		this.$store.state.progressNum = 1
		let Guids =encodeURIComponent(Guid)
		window.location =openurl+Guids
	}).catch(errs=>{
	  console.log(errs)
	})
  }
  

//关键字高亮显示
Vue.prototype.$brightkeyWords = function(val, keyWords) { //val:返回的date数据，keywords:文本框输入的关键词
	if (val.indexOf(keyWords) != -1) {
		return val.replace(keyWords, `<font color='red'>${keyWords}</font>`)
	} else {
		return val
	}
}
//不为空判断
Vue.prototype.$Bai = function(str) {
	if (str == undefined || str == '' || str == null || str == 'null' || str == 'undefined') {
		return true
	}
	return false
}
//是否有空格
Vue.prototype.$Space = (str) => {
		var reg = /\s/;
		if (reg.test(str)) {
			return true
		}
		return false;
	},
	//是不是IE
	Vue.prototype.$IEVersion = () => {
		if (!!window.ActiveXObject || "ActiveXObject" in window) {
			return true;
		} else {
			return false;
		}
	}
// //路由title
router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title;
	}
	let path = to.path;
	//判断是哪个页面 控住头部，轮播图，底部，登录版块的显示、隐藏
	if (/(Login|login_qq|LookforPassword|Nopassword|regist|Rss|ForgetPassword)/g.test(path)) {
		store.state.top = false
		store.state.user = false
		store.state.footer = false
		store.state.banner = false
		store.state.fileLoading = true
	} else {
		store.state.top = true
		store.state.user = true
		store.state.footer = true
		store.state.banner = true
		store.state.fileLoading =true
	}
	if(localStorage.getItem("userInfo")){
		let userInfo =JSON.parse(localStorage.getItem("userInfo"));
		let ExpiresDate=JSON.parse(localStorage.getItem("userInfo")).ExpiresDate
		let data=new Date(ExpiresDate).getTime()
		let nowData=new Date().getTime()
		if(data-nowData<=0){
		localStorage.removeItem("userInfo")
		}
	}
	next();
})
/* eslint-disable no-new */
new Vue({
	router,
	store,
	data() {
		return {}
	},
	async created() {
		if(sessionStorage.getItem("SetItem")){
			let steItem = JSON.parse(sessionStorage.getItem("SetItem"))
		steItem.map(item=>{
			if(item.SetItemID==1000){
				this.$store.state.Name= item.Item_Value
			}
		})
		}else{
			let params = [1000,1001,4530,6018,6019,230,6055,5000,5010,99,96,11,12,2960,2900,6021,310,4554]
        this.$store.dispatch("_getSet",params).then(res=>{
			let steItem =res.data.Data
				sessionStorage.setItem("SetItem",JSON.stringify(res.data.Data))
			steItem.map(item=>{
				if(item.SetItemID==1000){
					this.$store.state.Name= item.Item_Value
				}
			})
		})
		}
	
	},
	render: h => h(App)
}).$mount("#app")


router.afterEach((to, from, next) => {
	window.scrollTo(0,0);
})

